import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { useEffect, useState } from 'react';

const STORAGE_KEY = 'acs_active_tenant';

export interface Tenant {
  id: number;
  slug: string;
  name: string;
}

/** Hook: tenant actif (selected dans le switcher). Sync localStorage + intercepteur axios. */
export function useActiveTenant() {
  const [tenantId, setTenantIdState] = useState<number | null>(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? parseInt(stored, 10) : null;
  });

  function setTenantId(id: number | null) {
    if (id == null) {
      localStorage.removeItem(STORAGE_KEY);
    } else {
      localStorage.setItem(STORAGE_KEY, String(id));
    }
    setTenantIdState(id);
    // Recharge pour invalider toutes les queries
    window.location.reload();
  }

  return { tenantId, setTenantId };
}

/** Liste des tenants visibles à l'user courant. */
export function useTenants() {
  return useQuery({
    queryKey: ['tenants'],
    queryFn: () => api.get<Tenant[]>('/tenants').then((r) => r.data),
    staleTime: 5 * 60_000,
  });
}

/** No-op: l'intercepteur est maintenant installé module-level dans api.ts pour run dès le 1er render. */
export function useTenantInterceptor() {
  // intentionally empty
}
